var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-permission-page"},[_c('van-empty',{attrs:{"description":"当前账号没有可访问的页面权限"}},[_c('van-button',{attrs:{"type":"primary","round":""},on:{"click":_vm.goLogin}},[_vm._v("返回登录页")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }